import React, { Component } from 'react';
import ReactDom from 'react-dom';
import './App.css';
import { CSSTransitionGroup } from 'react-transition-group';
import { Scrollbars } from 'react-custom-scrollbars';
import Nfo from './nfo';


class NewRelease extends Component {
  
  
  constructor(props) {

 

    super(props);
  
    this.dropdown = this.dropdown.bind(this);
    this.state = {isActive: false};

  }
  
 
  componentDidUpdate() { 

    //dirty fix.

  
  }

  renderThumb() {
 
    const thumbStyle = {
        backgroundColor: 'rgba(255,255,255,0.2)',
        borderRadius: '100px',  
    };
    return (
        <div
            style={{ ...thumbStyle }}
     />
    );
}

  dropdown(){

    var test = (this.state.isActive === true) ? false : true;


    this.setState({isActive: test});

  }

  render(){

    
  if (!this.props.release) {
    return (false)//<div className="loader"><img src="../img/rolling.gif" /></div>

  } 
  //<img src={"/img/" + this.props.release.background} className="blaha" style={{ WebkitFilter: "blur(25px)", width: "100vw", height:"800px", overflow: "hidden",position:"absolute", transform: "scale(1.1)", margin: "0px"}}/>

    return (
      <div>
      <div id="release">   
      <CSSTransitionGroup
      transitionName="example"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}>
        <div className="background" style={{backgroundImage:  "url(/img/"+this.props.release.background+")"}} key={this.props.release.background}>   
        </div>
        </CSSTransitionGroup>
       
        {this.props.release.videoUrl ? <div className="videoWraper"><div className="video-container"><iframe className="youtube" title={this.props.release.name} src={`https://www.youtube.com/embed/${this.props.release.videoUrl}`} frameBorder="0" allowFullScreen/></div>
       <span className="dropdownbutton" onClick={this.dropdown}>{this.props.release.name.replace(/\s/g,'')}.nfo{this.state.isActive ? <span style={{float:'right', lineHeight:'10px', marginRight:'10px'}}>▲</span> : <span style={{float:'right', lineHeight:'10px', marginRight:'10px'}}>▼</span>}</span></div> :  <img className="youtubeplaceholder" alt={this.props.release.name} src={"../img/"+this.props.release.imageName} />}      
        <div id="info">         
          <h1 className="infoTextHeader">{this.props.release.name}</h1>
          <div className="infoText">
            <div className="infoSnippet">Ranked {this.props.release.rank} place in the {this.props.release.compo} compo @ {this.props.release.party}</div>
              <Scrollbars className="tjo" renderThumbVertical={this.renderThumb}>
                <p style={{padding:'0 20px 0 20px'}} dangerouslySetInnerHTML={{__html: this.props.release.info}}></p>
              </Scrollbars>
            <div className="linkSection">          
              <div><a href={this.props.release.pouet}>Pouet</a></div>
              <div><a href={this.props.release.demozoo}>Demozoo</a></div>               
                {this.props.release.liveVideo1 ? <div><a onClick={() => this.props.onLiveLinkSelect(this.props.release.liveVideo1)}>Live capture #1 (youtube)</a></div> : null}            
                {this.props.release.liveVideo2 ? <div><a onClick={() => this.props.onLiveLinkSelect(this.props.release.liveVideo2)}>Live capture #2 (youtube)</a></div> : null}
                {this.props.release.makingOf ? <div><a href={this.props.release.makingOf}>Making of</a></div> : null}
               <div><a onClick={this.dropdown}>Read .nfo</a></div>
            </div>
          </div>
          </div>
          
        </div>
          <div className={this.state.isActive ? 'active nfo' : 'nfo'}><Nfo nfo={this.props.release.name}/></div> </div>
      
     
    ); 
  }
}
export default NewRelease;


// WEBPACK FOOTER //
// ./src/newrelease.js